var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('client-only',[_c('HgDealDropdownSearch',{attrs:{"is-mobile":_vm.isMobile,"is-initial-search":_vm.isInital,"search-tags":_vm.filteredTags,"tags":_vm.highlightTags,"term":_vm.searchTerm},on:{"onUpdateSearchTerm":_vm.updateSearchTerm,"onTriggerSearch":_vm.triggerSearch}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }